import type { WorktreeLayoutFile } from '../worktree-layout-file.js';
import { loadWorktreeLayout } from '../worktree-layout-file.js';
import type { SessionWorktreeManagerOptions } from './types.js';
import { SessionWorktreeCache } from './session-worktree-cache.js';

export type SessionWorktreeManagerContext = {
  worktreesRootPath: string;
  log: SessionWorktreeManagerOptions['log'];
  cache: SessionWorktreeCache;
  layout: WorktreeLayoutFile;
};

export function createSessionWorktreeManagerContext(
  options: SessionWorktreeManagerOptions,
): SessionWorktreeManagerContext {
  return {
    worktreesRootPath: options.worktreesRootPath,
    log: options.log,
    cache: new SessionWorktreeCache(),
    layout: loadWorktreeLayout(),
  };
}
